import PropTypes from 'prop-types';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import {List, Segment} from 'semantic-ui-react';
import './SelectedComparableList.scss';
import Testimonial from './Testimonial';


export const TestimonialSegment = SortableElement(({testimonial, update, remove}) => {
  return (
    <List.Item key={`t.key${testimonial.index}`} className="sortable-testimonial">
      <Segment className="testimonial-segment" key={'s' + testimonial.index}>
        <Testimonial key={testimonial.index} testimonial={testimonial} update={update} remove={remove}/>
      </Segment>
    </List.Item>
  );
});

export const SortableTestimonials = SortableContainer(({testimonials, update, remove, ...props}) => {
  return (
    <List {...props} className="sortable-testimonial-list">
      {testimonials.map((t, i) => (
        t.id &&
        <TestimonialSegment key={i} testimonial={t} update={update} index={i} remove={remove}/>))
      }
    </List>
  );
});

export default function TestimonialList({testimonials, update, remove, onSortEnd}) {
  return (
    <SortableTestimonials testimonials={testimonials}
                          lockAxis="y"
                          disableAutoscroll
                          update={update}
                          remove={remove}
                          onSortEnd={onSortEnd}
                          useDragHandle/>
  );
}

TestimonialList.propTypes = {
  testimonials: PropTypes.array.isRequired,
  onSortEnd: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
};
